import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "main-content" };
import List from '@/views/UserManagement/UserList/List.vue';
import SubController from '@/views/UserManagement/UserList/SubController.vue';
import UserPermissionSettingDialog from '@/views/Dialog/UserPermissionSettingDialog/index.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(SubController),
                _createVNode(List),
                _createVNode(UserPermissionSettingDialog)
            ]));
        };
    }
});
